import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[PhoneFormat]'
})
export class PhoneFormatDirective {

  private el: HTMLInputElement;

  constructor(private elementRef: ElementRef, private control: NgControl) {
    this.el = this.elementRef.nativeElement;
  }

  @HostListener('keyup', ['$event.target.value'])
  onKeyup(value: string) {

    const regex: RegExp = /\D/g;

    let newValue: string = value;

    // clear value
    if (value.match(regex)) {
      newValue = newValue.replace(regex, '');
    }

    if (newValue.length === 0) {
      newValue = '';
    } else if (newValue.length <= 2) {
      newValue = newValue.replace(/^(\d{0,2})/, '($1');
    } else if (newValue.length <= 6) {
      newValue = newValue.replace(/^(\d{0,2})(\d{0,4})/, '($1) $2');
    } else if (newValue.length <= 10) {
      newValue = newValue.replace(/^(\d{0,2})(\d{0,4})(\d{0,4})/, '($1) $2-$3');
    } else {
      newValue = newValue.replace(/^(\d{0,2})(\d{4,5})(\d{0,4})/, '($1) $2-$3');
    }

    // set value in element
    this.el.value = newValue;
    this.control.control.setValue(newValue);
  }
}
